<template>
  <v-row class="fill-height">
    <v-col>
      <v-card
        flat
        @drop.prevent="fileUploadSubmit($event)"
        @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true"
        @dragleave.prevent="dragover = false"
        :class="{ 'grey lighten-2': dragover }"
      >
        <v-container v-if="$async.upload.$pending || isFilesLoading">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              Идет загрузка файлов
            </v-col>
            <v-col cols="6">
              <v-progress-linear color="primary" indeterminate rounded height="6" />
            </v-col>
          </v-row>
        </v-container>
        <v-card-text v-else>
          <v-row class="d-flex flex-column" dense align="center" justify="center">
            <label for="upload-file" class="pointer">
              <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60">
                mdi-cloud-upload
              </v-icon>
              <input
                :multiple="multiple"
                :accept="`${fileType.anyFormat},${fileType.formats.join(',')}`"
                class="hidden"
                type="file"
                id="upload-file"
                name="upload-file"
                @change.stop="fileUploadSubmit(null, $event.target.files)"
              />
            </label>
            <p>Перетащите вашы файлы сюда или нажмите, чтобы выбрать.</p>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import uploadFileMutation from '@/services/gql/types/Files/mutations/uploadFile.gql'
export default {
  name: 'MediaFileLoader',
  props: {
    fileType: {
      type: Object,
      default: () => ({}),
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    returnFileOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dragover: false,
      isFilesLoading: false
    }
  },
  methods: {
    fileUploadSubmit (e = null, files = []) {
      this.dragover = false
      if (e) this.submit(e.dataTransfer.files)
      else if (!e) this.submit(files)
    },
    async submit (files) {
      try {
        this.isFilesLoading = true
        for (const file of files) {
          if (this.returnFileOnly) {
            this.$emit('files-uploaded', file)
          } else {
            const item = await this.$async.upload.$perform({
              data: { file, mediaLibrary: true } // @TODO
            })
            this.$emit('files-uploaded', item.data.upload.id)
          }
        }
        this.$emit('update-grid')
        this.$emit('close-dialog')
        if (!this.returnFileOnly) this.$successMsg('Файлы загружены')
        this.isFilesLoading = false
      } catch (e) {
        if (!this.returnFileOnly) this.$handleApiError(e.graphQLErrors, 'Ошибка при загрузке файла')
        this.$emit('close-dialog')
      }
    }
  },
  async: {
    upload (variables) {
      return this.$apollo.mutate({
        mutation: uploadFileMutation,
        variables
      })
    }
  }
}
</script>

<style scoped>
.hidden {
  visibility: hidden;
  width: 1px;
  height: 1px;
}
</style>
